__turbopack_context__.v({
  "subheading": "ItineraryCardSubheading-module__s67Qgq__subheading",
});
